module.exports = __webpack_public_path__ + "static/media/bg_competences_tablette.00159e48.jpg";